import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a DOM manipulation error - don't set hasError to true
    if (error.message && (
      error.message.includes('removeChild') ||
      error.message.includes('appendChild') ||
      error.message.includes('insertBefore') ||
      error.message.includes('NotFoundError') ||
      error.message.includes('Failed to execute') ||
      error.message.includes('The node to be removed is not a child')
    )) {
      // For DOM manipulation errors, don't show error UI
      console.warn('DOM manipulation error prevented by ErrorBoundary:', error.message);
      return { hasError: false };
    }
    
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details
    console.warn('ErrorBoundary caught an error:', error, errorInfo);
    
    // Check if it's a DOM manipulation error
    if (error.message && (
      error.message.includes('removeChild') ||
      error.message.includes('appendChild') ||
      error.message.includes('insertBefore') ||
      error.message.includes('NotFoundError') ||
      error.message.includes('Failed to execute') ||
      error.message.includes('The node to be removed is not a child')
    )) {
      console.warn('DOM manipulation error caught by ErrorBoundary:', error.message);
      // Don't show error UI for DOM manipulation errors, just log them
      // Reset error state to prevent infinite loop
      this.setState({ hasError: false, error: null, errorInfo: null });
      return;
    }

    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      // Check if it's a DOM manipulation error - don't show error UI
      if (this.state.error && this.state.error.message && (
        this.state.error.message.includes('removeChild') ||
        this.state.error.message.includes('appendChild') ||
        this.state.error.message.includes('insertBefore') ||
        this.state.error.message.includes('NotFoundError') ||
        this.state.error.message.includes('Failed to execute') ||
        this.state.error.message.includes('The node to be removed is not a child')
      )) {
        // For DOM manipulation errors, just render children normally
        // Reset error state to prevent infinite loop
        this.setState({ hasError: false, error: null, errorInfo: null });
        return this.props.children;
      }

      // For other errors, show error UI
      return (
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="alert alert-danger">
                <h4 className="alert-heading">Terjadi Kesalahan</h4>
                <p>Maaf, terjadi kesalahan yang tidak terduga. Silakan coba lagi.</p>
                <hr />
                <div className="d-flex justify-content-between">
                  <button 
                    className="btn btn-outline-danger" 
                    onClick={this.handleRetry}
                  >
                    Coba Lagi
                  </button>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => window.location.reload()}
                  >
                    Refresh Halaman
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
